import * as PIXI from "pixi.js"
import PixiScene from "../PixiScene";
import PixiPile from "./PixiPile";
import PixiSelector from "./PixiSelector";
import PixiType from "./PixiType";
//@ts-ignore
import { ColorOverlayFilter, OutlineFilter } from 'pixi-filters';
import {ICardM, IPileM} from "./model/MTypes";
import EventApi from "../../../../../api/EventsApi";
import Scribe from "./paint/Scribe";
import Tweener from "./Tweener";
import PixiMessenger from "./PixiMessenger";

interface ICard {
    backface_src: string;
    face_src: string;
    flipped: boolean;
    id: number;
    title: string;
    width: number;
    height: number;
    type: number;
    onTable?: boolean;
    eternal?: boolean;
    paint?: any;
    backfacePaint?: any;
    metaType?: string;
}

interface IState {
    scale: number;
    x: number;
    y: number;
}

export default class PixiCard extends PIXI.Container {

    private static colorFilter = new ColorOverlayFilter([1,0.5,0], 0.5);
    private readonly SHOW_OUTLINE = false;
    private readonly scene: PixiScene;
    public readonly config: ICard;
    private readonly mat = new PIXI.Sprite(PIXI.Texture.WHITE);
    private readonly isRandomCard: boolean = false;

    private parentContainer: PIXI.Container | null = null;
    private similoButton: PIXI.Container | null = null;
    private btnFace = new PIXI.Graphics();
    private cardFace = new PIXI.Sprite;
    private cardBack = new PIXI.Sprite;
    private cardText = new PIXI.Text('');
    private similoButtonText = new PIXI.Text('');
    private flipped: boolean = false;
    private initFlipped: boolean = false;
    private isAnimating: boolean = false;
    private isBlurred: boolean = false;
    private isMarked: boolean = false;
    private isSelected: boolean = false;
    private isWaiting: boolean = false;
    private flipDrawn: boolean = false;

    private timer: number = 0;
    private waitTimer: number = 0;
    private brightness: number = 0;
    private cardHandScale: number = 1;
    private pileZIndex: number = -1;
    private initPromise: Promise<void> | null = null;
    private startTexture: PIXI.RenderTexture | null = null;
    private startTextureBack: PIXI.RenderTexture | null = null;
    private startAngle: number = 0;

    public readonly tweener: Tweener;
    public readonly objType = PixiType.GAME_OBJ_CARD;
    public readonly hoverScale = 1.32;
    public parentPile: PixiPile | null = null;
    public handIndex: number = -1;
    public newState: IState = { scale: 1, x: 0, y: 0 };
    public closeMenu: (()=>void) | null = null;
    public readonly outlineFilter = new OutlineFilter(4, 0xF65A00);

    constructor(scene: PixiScene, config: ICard, pileZ = 0) {
        super();
        this.scene = scene;
        this.config = config;
        this.tweener = new Tweener(this);
        if (this.config.paint) {
            this.config.paint.cardId = config.id;
        }
        if (this.config.backfacePaint) {
            this.config.backfacePaint.cardId = config.id;
        }
        this.isRandomCard = 2 === config.type;
        this.init(pileZ);
        EventApi.addEventListener(EventApi.EDIT_DONE, (e: any) => {
            if (this.parent && this.cardId === e.detail.cardId) {
                if ('backfacePaint' === e.detail.side) {
                    this.config.backfacePaint = e.detail;
                }
                else {
                    this.config.paint = e.detail;
                }
                this.drawScript();
            }
        });
    }

    /**
     * Инициализация
     */
    private init(pileZ = 0) {
        const config = this.config;
        this.cardHandScale = this.scene.handContainer.getHandScale(this);
        const promiseF = this.getSprite(config.title, config.face_src, pileZ)
            .then(sprite => { this.cardFace = sprite; });
        const promiseB = this.getSprite(config.title + '_flipped', config.backface_src, pileZ)
            .then(sprite => { this.cardBack = sprite; });
        this.initPromise = Promise.all([ promiseF, promiseB ])
            .then(() => {
                const width  = this.cardFace.width, height = this.cardFace.height;
                this.mat.width  = width;
                this.mat.height = height;
                this.mat.anchor.set(0.5);
                this.mat.alpha = 0;
                this.addChild(this.mat);
                this.addChild(this.cardBack);
                this.addChild(this.cardFace);

                this.cardBack.width  = this.cardFace.width;
                this.cardBack.height = this.cardFace.height;

                // const face = new PIXI.Sprite(this.cardFace.texture);
                // face.filters = [new ColorOverlayFilter(0xffffff)];
                // const maskTexture = PIXI.RenderTexture.create({ width, height });
                // this.scene.renderer!.render(face, { renderTexture: maskTexture });
                // const backMask = new PIXI.Sprite(maskTexture);
                //
                // const backArt = new PIXI.Sprite(this.cardBack.texture);
                // backMask.width  = backArt.width;
                // backMask.height = backArt.height;
                // backArt.width  = width;
                // backArt.height = height;
                // backArt.addChild(backMask);
                // backArt.mask = backMask;
                //
                // const backTexture = PIXI.RenderTexture.create({ width, height });
                // this.scene.renderer!.render(backArt, { renderTexture: backTexture });
                // this.cardBack.texture = backTexture;

                this.flipped = config.flipped;
                this.initFlipped = this.flipped;
                this.cardBack.visible = config.flipped;
                this.cardFace.visible = !config.flipped;
                this.scene.setAttr(this, { src: config.flipped? config.backface_src: config.face_src });

                this.name = config.title + '_card';
                this.filters = [];

                if (this.isRandomCard) {
                    this.addRandomCardStuff();
                }
                if (config.paint && !this.flipped || config.backfacePaint && this.flipped) {
                    this.drawScript();
                }

                // console.log('%c ### >>>', 'color: #f0f', this.scene.isSimilo);
                // if (this.scene.isSimilo) {
                this.addSimiloButton();
                // }

                // this.addDebugHUD();
            });
    }

    /**
     * Добавить кнопку для Similo
     */
    private addSimiloButton(): void
    {
        // if (this.blocked || this.locked || this.isStatic || !this.solo) {
        //     return;
        // }
        const btn = new PIXI.Container();
        const btnText = new PIXI.Text(this.flipped ? 'Cancel' : 'Remove');
        btnText.style = new PIXI.TextStyle({
            align: 'center',
            fill: 0xffffff,
            fontFamily: 'Arial',
            fontSize: 48,
            fontWeight: 'bold',
        });
        btnText.anchor.set(0.5);
        const btnWidth = this.config.width, btnHeight = 96;

        const btnFace = this.btnFace.beginFill(0xF65A00)
            .drawRoundedRect(-btnWidth/2, -btnHeight/2, btnWidth, btnHeight, btnHeight/8)
            .endFill();
        btn.addChild(btnFace);
        btnFace.addChild(btnText);
        btnFace.visible = false;

        btnFace.interactive = true;
        btnFace.on('pointerup', e => {
            btnFace.visible = false;
            PixiSelector.clearAll();
            PixiMessenger.sendFlip(this, true);
        });

        this.addChild(btn);
        btnFace.y = (this.config.height - btnHeight) / 2;

        btn.visible = false;
        this.similoButton = btn;
        this.similoButtonText = btnText;
    }

    /**
     * Получить инициализированный экземпляр
     */
    public async getInit() {
        await this.initPromise;
        return this;
    }

    /**
     * Элементы рандомной карты в админке
     */
    private addRandomCardStuff(): void
    {
        const config = this.config;
        const randomCardStuff = new PIXI.Container;

        const frame = new PIXI.Graphics();
        frame.lineStyle(2);
        const rad = 8, rad2 = rad+rad;
        frame.drawRoundedRect(rad, rad, config.width-rad2, config.height-rad2, rad2);
        randomCardStuff.addChild(frame);

        this.cardText = new PIXI.Text(this.getRandomCardText());
        this.cardText.style.align = 'center';
        this.cardText.anchor.set(0.5, 0.5);
        randomCardStuff.addChild(this.cardText);
        this.cardText.position.set(config.width/2, config.height/2);

        this.addChild(randomCardStuff);
        randomCardStuff.x -= config.width/2;
        randomCardStuff.y -= config.height/2;
    }

    /**
     * Текст для рандомной карты в админке
     */
    private getRandomCardText(): string
    {
        return `Random element\n${(this.config as any).id}\nfrom stack\n${(this.config as any).stackId}\n\n` + (this.flipped? 'Back': 'Front');
    }

    /**
     * Создание спрайтов
     */
    private getSprite(spriteTitle: string, spriteSrc: string, pileZ = 0): Promise<PIXI.Sprite>
    {
        let sprite: PIXI.Sprite;
        const getDefault = (tint: number = 0) => {
            let s = new PIXI.Sprite(PIXI.Texture.WHITE);
            s.width  = this.config.width;
            s.height = this.config.height;
            if (tint) {
                s.tint = tint;
            }
            return s;
        };
        const setAttributes = (s: PIXI.Sprite) => {
            s.anchor.set(0.5);
            s.name = spriteTitle;
            return s;
        };
        if (this.isRandomCard || pileZ > 1) {
            sprite = getDefault(this.isRandomCard ? 0 : 0x333333);
            // this.scene.setAttr(sprite, { src: spriteSrc });
            // this.scene.cardMap.set(spriteTitle, sprite);

            return new Promise((resolve) => {
                resolve(setAttributes(sprite));
            });

        }
        sprite = PIXI.Sprite.from(spriteSrc);

        return new Promise((resolve, reject) => {
            if (sprite.texture.baseTexture.valid) {
                resolve(setAttributes(sprite))
            }
            else {
                sprite.texture.baseTexture.on('loaded', () => resolve(setAttributes(sprite)));
                sprite.texture.baseTexture.on('error', (err) => {
                    // reject(err);
                    console.warn(err.message);
                    sprite = getDefault(0xff00ff);
                    resolve(setAttributes(sprite));
                });
            }
        });
    }

    /**
     * Получить ID карты
     */
    public get cardId(): number
    {
        return this.config.id;
    }

    /**
     * Получить ID родительской стопки
     */
    public get pileId(): number
    {
        return this.parentPile?.pileId ?? 0;
    }

    /**
     * Получить родительскую стопку
     */
    public get pile(): PixiPile|null
    {
        return this.parentPile;
    }

    public getAttrs(): any //TODO: убрать старые атрибуты
    {
        return (this as any)?.attrs;
    }

    public get zone(): string //TODO: убрать старые атрибуты
    {
        return (this as any)?.attrs?.zone ?? '';
    }

    /**
     * Оригинальный размер
     */
    public get size()
    {
        return { width: this.config.width, height: this.config.height };
    }

    /**
     * Сравнить размер
     */
    public theSameSizeAs(card: PixiCard | undefined): boolean
    {
        if (!card || !card.size) {
            return false;
        }
        return ((this.size.width === card.size.width) && (this.size.height === card.size.height));
    }

    /**
     * Карта перевернута
     */
    public get isFlipped(): boolean
    {
        return this.config.flipped;
    }

    /**
     * Карта: получить урл активной стороны
     */
    public get cardSrc(): string
    {
        return this.flipped ? this.config.backface_src : this.config.face_src;
    }

    /**
     * Карта: получить скрипт активной стороны
     */
    public get paintActions(): Array<any>
    {
        const paint = this.flipped ? this.config.backfacePaint : this.config.paint;
        return paint?.actions ?? [];
    }

    /**
     * Карта: получить урл маски для дефолтной рубашки
     */
    public get bgSrc(): string
    {
        // return this.flipped ? this.config.face_src : '';
        return this.flipped ? this.config.backface_src : '';
    }

    /**
     * Карта: получить урл лицевой стороны
     */
    public get cardFaceSrc(): string
    {
        return this.config.face_src;
    }

    /**
     * Карта: получить урл рубашки
     */
    public get cardBackfaceSrc(): string
    {
        return this.config.backface_src;
    }

    /**
     * Размер стопки
     */
    public get pileLength(): number
    {
        return this.parentPile?.getPileLength() ?? 0;
    }

    public set selected(value: boolean) {
        this.isSelected = value;

        if (this.pileLength > 1) {
            this.setTint(this.isSelected ? 0xcccccc : 0xffffff);
        }

        if (!value) {
            this.resetFilter();
            if ('hand' === this.zone) {
                this.scene.handContainer.setHandPos(this);
            }
        }
    }

    /**
     * Снятие статуса "выделено" без побочных эффектов
     */
    public deselectByOther() {
        this.isSelected = false;
    }

    /**
     * Получение статуса "выделено"
     */
    public get selected() {
        return this.isSelected;
    }

    /**
     * Простой флип
     */
    public flip(value?: boolean) {
        let flipped = value ?? ! this.flipped;
        this.flipped = flipped;
        this.cardBack.visible = flipped;
        this.cardFace.visible = ! flipped;
        if (this.isRandomCard) {
            this.cardText.text = this.getRandomCardText();
        }
    }

    /**
     * Флип с анимацией
     */
    public flipAnim(value?: boolean, soloDrag?: boolean, callback?:(() => void)) {
        if (this.isAnimating || this.flipped === value) {
            return;
        }
        console.log('%c ### flip tween start', 'color: #f0f', performance.now());
        const duration = 150;
        let width = this.cardFace.width;
        let isSoloDrag = soloDrag ?? false;
        let flipped = value ?? ! this.flipped;
        let pile = this.parentPile;

        const onMidpoint = () => {
            this.flipped = flipped;
            this.cardBack.width = 0;
            this.cardFace.width = 0;
            this.cardBack.visible = flipped;
            this.cardFace.visible = ! flipped;
            if (!soloDrag && this.flipTopCard) {
                this.flipTopCard.alpha = (flipped === this.initFlipped) ? 0.5 : 1;
            }
            flipComplete();
        };

        const flipStart = () => {
            this.isAnimating = true;
            this.showSimiloButton(false);
            if (pile && !isSoloDrag) {
                pile.showRest(false);
            }
            this.tweener.addFlipTween(0, duration, onMidpoint);
        };

        const onAftermath = () => {
            this.cardBack.width = width;
            this.cardFace.width = width;
            if (pile && !isSoloDrag) {
                pile.showRest(true);
            }
            this.showSimiloButton(this.scene.isSimilo);
            this.isAnimating = false;
            if ('hand' === this.zone) {
                this.scene.handContainer.flipping = false;
                this.scene.hoverOver();
            }
            callback ? callback() : void 0;
            console.log('%c ### flip tween complete', 'color: #f0f', performance.now());

            if (!this.flipDrawn) {
                this.flipDrawn = true;
                if (this.config.paint && !this.flipped || this.config.backfacePaint && this.flipped) {
                    this.drawScript();
                }
            }
        };

        const flipComplete = () => {
            if (pile && !isSoloDrag) {
                pile.flipRest();
            }
            this.tweener.addFlipTween(width, duration, onAftermath);
        };
        flipStart();
        if (!soloDrag && this.flipTopCard) {
            this.flipTopCard.flipAnim(value);
        }
    }

    /**
     * Карта: выбрана верхняя в пачке?
     */
    public isTop(): boolean
    {
        return (this.pileLength > 1 && ! this.selected);
    }

    public moveRest(x: number, y: number): void
    {
        if (this.parentPile) {
            if (this.selected) {
                this.parentPile.moveRest(x, y);
            }
            else {
                this.parentPile.update();
            }
        }
    }

    /**
     * Работа с таймером для пачки:
     */
    public get marked() {
        return this.isMarked;
    }

    public setTimer(): void
    {
        if (! this.isMarked && 0 === this.timer) {
            this.timer = window.setTimeout(this.onTimer.bind(this), 1000)
        }
    }

    public setTint(tint: number): void
    {
        this.art.tint = tint;
    }

    public paint(tint: boolean): void
    {
        this.art.filters = this.art.filters || [];
        if (tint) {
            if (!this.art.filters.includes(PixiCard.colorFilter)) {
                this.art.filters.push(PixiCard.colorFilter);
            }
        }
        else {
            this.art.filters = this.art.filters.filter(it => it !== PixiCard.colorFilter);
        }
    }

    /**
     * Установить яркость
     * @param value
     */
    public setBrightness(value: number = 0.7): void
    {
        if (value && !this.brightness) {
            let colorMatrix = new PIXI.filters.ColorMatrixFilter();
            //@ts-ignore
            colorMatrix.brightness(value, false);
            this.filters = this.filters || [];
            this.filters.push(colorMatrix);
        }
        this.brightness = value;
        if (!value) {
            this.filters = [];
        }
    }

    public onTimer(): void
    {
        this.timer = 0;
        // console.log('%c ### onTimer:', 'color: #f0f', this.cardId, this.scene.hoverId);
        if (this.cardId !== this.scene.hoverId) {
            return;
        }
        if (!this.isMarked) {
            this.isMarked = true;
            this.paint(true);
        }
    }

    public clearTimer(): void
    {
        if (this.timer > 0) {
            window.clearTimeout(this.timer);
        }
        this.timer = 0;
        if (this.isMarked) {
            this.isMarked = false;
            this.paint(false);
        }
    }

    /**
     * Переключение блокировки
     */
    public toggleLock(value?: boolean) {
        this.locked = value ?? ! this.locked;
    }

    /**
     * Сеттер блокировки
     */
    public set locked(value: boolean)
    {
        if (this.parentPile) {
            this.parentPile.locked = value;
        }
    }

    /**
     * Геттер блокировки
     */
    public get locked() {
        return this.parentPile?.locked ?? false;
    }

    /**
     * Геттер статичной блокировки
     */
    public get isStatic() {
        return this.parentPile?.inPermanentLock() ?? false;
    }

    /**
     * Поднять на верхний слой для перемещения
     */
    public goUp(forced: boolean = false) {
        let list = PixiSelector.getSelected(this.zone);
        if (! list.includes(this)) {
            list.push(this);
        }
        if (! this.parentContainer) {
            list.forEach(it => {
                let card = it as PixiCard;
                card.setFilterWithShadow(this.scene.outlineFilter, this.scene.dropShadowFilter, forced);
                it.parentContainer = this.parent;

                this.scene.tableContainer.adjustTop();
                this.scene.topContainer.addChild(card);
                if (card.flipTopCard) {
                    this.scene.topContainer.addChild(card.flipTopCard);
                }
            });
        }
    }

    /**
     * Вернуть на стол / в руку после перемещения
     */
    public goDown(zone?: string) {
        let list = PixiSelector.getSelected(this.zone);
        if (! list.includes(this)) {
            list.push(this);
        }
        if (this.parentContainer) {
            if (this.flipTopCard) {
                this.alpha = 1;
                this.flipTopCard.alpha = 0;
            }
            list.forEach(it => {
                let card = it as PixiCard;
                if ('hand' === card.zone) {
                    card.scale.set(this.handScale);
                    card.parentContainer?.addChild(card);
                }
                else if ('table' === card.zone) {
                    this.scene.tableContainer.addCard(card);
                    if (card.flipTopCard) {
                        this.scene.tableContainer.addCard(card.flipTopCard);
                    }
                }
                else {
                    this.parentContainer?.addChild(card);
                }

                card.setFilter(this.scene.outlineFilter);
                it.parentContainer = null;
            });
        }
    }

    /**
     * Масштаб карты в руке
     */
    public get handScale():number {
        return this.cardHandScale;
    }

    /**
     * Начало перемещения
     */
    public move(x: number, y: number, moveSelected: boolean = false): boolean {
        let delta = { x: x - this.x, y: y - this.y };
        let list: Array<PixiCard> = [];
        this.newState = { scale: this.scale.x, x: x, y: y };

        if (moveSelected) {
            list = PixiSelector.getSelected(this.zone);
            list.forEach(it => {
                let card = it as PixiCard;
                if (card !== this) {
                    card.newState = { scale: card.scale.x, x: card.x + delta.x, y: card.y + delta.y };
                }
            });
        }
        const isMoveValid = this.isMoveValid(list);
        if (isMoveValid) {
            this.moveEnd(list);
        }
        return isMoveValid;
    }

    /**
     * Проверка перемещения
     */
    public isMoveValid(list: Array<PixiCard>): boolean
    {
        if (PixiType.ZONE_HAND === this.zone && this.scene.bottomOverHand) {
            return true;
        }
        const padding = { x: 8, y: 8 };
        let posMin = {
            x: this.newState.x - this.size.width/2  - padding.x,
            y: this.newState.y - this.size.height/2 - padding.y
        };
        let posMax = {
            x: this.newState.x + this.size.width/2  + padding.x,
            y: this.newState.y + this.size.height/2 + padding.y
        };
        list.forEach(card => {
            posMin.x = Math.min(posMin.x, card.newState.x - card.width/2  - padding.x);
            posMin.y = Math.min(posMin.y, card.newState.y - card.height/2 - padding.y);
            posMax.x = Math.max(posMax.x, card.newState.x + card.width/2  + padding.x);
            posMax.y = Math.max(posMax.y, card.newState.y + card.height/2 + padding.y);
        });
        // this.scene.tableContainer.startBox(new PIXI.Point(posMin.x, posMin.y));
        // this.scene.tableContainer.drawBox(new PIXI.Point(posMax.x, posMax.y));

        const gameField = this.scene.gameField;
        let valid = posMin.x > 0 && posMin.y > 0 && posMax.x < gameField.width;
        if (!this.scene.handContainer.visible || !this.parentContainer) {
            valid = valid && posMax.y < gameField.height;
        }
        return valid;
    }

    /**
     * Завершение перемещения
     */
    private moveEnd(list: Array<PixiCard>) {
        this.x = this.newState.x;
        this.y = (this.y < this.newState.y && this.scene.isCardBottomUnderHand()) ? this.y : this.newState.y;
        this.moveRest(this.newState.x, this.newState.y);

        list.forEach(it => {
            let card = it as PixiCard;
            if (card !== this) {
                card.x = card.newState.x;
                card.y = card.newState.y;
                card.moveRest(card.x, card.y);
            }
        });
    }

    /**
     * Видимый спрайт
     */
    public get art(): PIXI.Sprite
    {
        return this.flipped ? this.cardBack : this.cardFace;
    }

    /**
     * Сеттер блюра
     * @param value
     */
    public set blurred(value: boolean)
    {
        this.isBlurred = value;
    }

    /**
     * Геттер блюра
     */
    public get blurred() {
        return this.isBlurred;
    }

    /**
     * Применить блюр
     */
    public applyBlur(sepiaFilter:PIXI.Filter, outlineFilter:PIXI.Filter) {
        if (!this.isStatic) {
            this.art.filters = this.blurred ? [ sepiaFilter, outlineFilter ] : [ outlineFilter ];
        }
    }

    /**
     * Применить фильтр
     */
    public setFilter(filter: PIXI.Filter, forced: boolean = false) {
        if (this.SHOW_OUTLINE && this.parentPile) {
            this.parentPile.filters = (this.selected || forced) ? [filter] : [];
            this.parentPile.showOutline(this.selected || forced);
        }
        else {
            this.filters = (this.selected || forced) ? [filter] : [];
        }
    }

    /**
     * Очистить фильтр
     */
    public resetFilter() {
        if (this.SHOW_OUTLINE && this.parentPile) {
            this.parentPile.filters = [];
            this.parentPile.showOutline(false);
        }
        else {
            this.filters = [];
        }
    }

    /**
     * Применить фильтр с тенью
     */
    public setFilterWithShadow(filter: PIXI.Filter, shadow: PIXI.Filter, forced: boolean = false) {
        if (this.SHOW_OUTLINE && this.parentPile) {
            this.parentPile.filters = (this.selected || forced) ? [filter, shadow] : [shadow];
            this.parentPile.showOutline(this.selected || forced);
        }
        else {
            this.filters = (this.selected || forced) ? [filter, shadow] : [shadow];
        }
    }

    /**
     * Карта в состоянии анимации:
     */
    public get isAnimatingNow(): boolean
    {
        return this.isAnimating;
    }

    /**
     * Карта на переднем слое:
     */
    public get isHovering(): boolean
    {
        return !!this.parentContainer;
    }

    /**
     * Восстановить положение карты:
     */
    public snapBack() {
        if (this.parentPile) {
            this.x = this.parentPile.state.x;
            this.y = this.parentPile.state.y;
        }

    }

    /**
     * HUD для отладки:
     */
    public addDebugHUD(): void
    {
        const width  = this.width;
        const height = this.height;
        const hud = new PIXI.Graphics();
        /*/
        hud.lineStyle(2, 0xffffff);
        hud.drawRect(-width/2, -height/2, width, height);
        // hud.moveTo(-width/2, 0); hud.lineTo(width/2, 0);
        // hud.moveTo(0, -height/2); hud.lineTo(0, height/2);
        hud.moveTo(-width/2, -height/2); hud.lineTo(width/2, height/2);
        hud.moveTo(width/2, -height/2); hud.lineTo(-width/2, height/2);
        /*/

        hud.beginFill(0, 0.5);
        hud.drawRect(-width/2, height/2-128, width, 128);
        hud.endFill();
        this.addChild(hud);

        const idText = new PIXI.Text(''+this.config.id, {fontSize:128, fill:0xffffff, align:'center'});
        this.addChild(idText);
        idText.y = height/2 - idText.height;
    }

    /**
     * Создание пачки из конфига
     */
    public static create(conf: ICardM, scene: PixiScene): PixiCard
    {
        return new PixiCard(scene, conf);
    }

    /**
     * Получить топ для флипа
     */
    public get flipTopCard() {
        return this.parentPile?.flipTopCard;
    }

    /**
     * Создание клона
     */
    public createClone(): PixiCard
    {
        const config = {...this.config};
        config.flipped = this.flipped;
        const cloneCard = new PixiCard(this.scene, config);
        cloneCard.interactive = false;
        cloneCard.x = this.x;
        cloneCard.y = this.y;
        cloneCard.locked = true;
        this.scene.topContainer.addChild(cloneCard);
        return cloneCard;
    }

    /**
     * "Высота" карты в пачке
     */
    public get pileZ() {
        return this.pileZIndex;
    }
    public set pileZ(z: number) {
        this.pileZIndex = z;
    }

    /**
     * Рисование на карте
     */
    private drawScript() {
        if (!this.parent) {
            return;
        }
        this.initPromise?.then(() => {
            const renderer = this.scene.renderer;
            const data = this.flipped ? this.config.backfacePaint : this.config.paint;
            const { width, height } = this.art;
            const offset = new PIXI.Matrix().translate(width/2, height/2);

            if (renderer && data && this.cardId === data.cardId) {
                const scribe = new Scribe(renderer, false);
                if (this.flipped) {
                    if (!this.startTextureBack) {
                        this.startTextureBack = PIXI.RenderTexture.create({ width, height });
                        renderer.render(this.art, { renderTexture: this.startTextureBack, clear: false, transform: offset });
                    }
                    scribe.src = new PIXI.Sprite(this.startTextureBack);
                }
                else {
                    if (!this.startTexture) {
                        this.startTexture = PIXI.RenderTexture.create({ width, height });
                        renderer.render(this.art, { renderTexture: this.startTexture, clear: false, transform: offset });
                    }
                    scribe.src = new PIXI.Sprite(this.startTexture);
                }
                scribe.drawScript(data.actions, data.scale);
                this.art.texture = scribe.texture;
            }
        });
    }

    /**
     * Вращение карты
     * @param angle
     * @param solo
     */
    public rotate(angle: number, solo: boolean) {
        //переменная наследуется от PixiContainer
        this.angle = angle;
        this.startAngle = angle;
        if (!solo) {
            this.parentPile?.rotateRest(angle);
        }
    }

    /**
     * Относительное вращение карты
     * @param delta
     * @param solo
     */
    public rotateDelta(delta: number, solo: boolean) {
        //переменная наследуется от PixiContainer
        this.angle += delta;
        if (!solo) {
            this.parentPile?.rotateRest(this.angle);
        }
    }

    /**
     * Получить текущую дельту угла
     */
    public get angleDelta() {
        return this.angle - this.startAngle;
    }

    /**
     * Границы карты с учётом вращения
     * Возвращает опорные точки: углы, центры сторон, центр карты.
     * Используется для шифт-выделения повёрнутых карт.
     */
    public get points(): Array<PIXI.Point> {
        const halfWidth = this.size.width / 2, halfHeight = this.size.height / 2;
        const getPoint = (dx: number, dy: number) => {
            const R = Math.hypot(dx, dy), A = Math.atan2(dy, dx);
            return new PIXI.Point(
                //переменная rotation наследуется от PixiContainer
                this.x + R * Math.cos(A + this.rotation),
                this.y + R * Math.sin(A + this.rotation)
            );
        };
        return [ // Опорные точки:
            getPoint(-halfWidth, -halfHeight), // left - top
            getPoint(0, -halfHeight), // center - top
            getPoint(halfWidth, -halfHeight), // right - top
            getPoint(-halfWidth, 0), // left - middle
            getPoint(0, 0), // center - middle
            getPoint(halfWidth, 0), // right - middle
            getPoint(-halfWidth, halfHeight), // left - top
            getPoint(0, halfHeight), // center - middle
            getPoint(halfWidth, halfHeight), // right - middle
        ];
    }

    /**
     * Ожидание окончания анимации
     */
    public get waiting() {
        return this.isWaiting;
    }
    public wait() {
        this.isWaiting = true;
        if (this.waitTimer > 0) {
            window.clearTimeout(this.waitTimer);
        }
        this.waitTimer = window.setTimeout(() => this.isWaiting = false, 1000);
    }

    /**
     * Карта находится под управлением какого-то игрока и заблокирована
     */
    public get blocked(): boolean
    {
        return this.parentPile?.inUsageBlocked() ?? false;
    }

    /**
     * Карта находится в пачке из 1 карты
     */
    public get solo(): boolean
    {
        return this.parentPile ? (1 === this.parentPile.cardListLength) : false;
    }

    /**
     * Верхняя (активная) карта пачки
     */
    public get isTopCard(): boolean
    {
        return (this.parentPile?.topCard.cardId === this.cardId);
    }

    /**
     * Показать / скрыть кнопку Similo
     */
    public showSimiloButton(value: boolean) {
        if (this.similoButton && this.scene.isSimiloCard(this.cardId)) {
            if (value) {
                this.similoButtonText.text = this.flipped ? 'Cancel' : 'Remove';
            }
            this.similoButton.visible = value;
        }
    }
    public showSimiloButtonFace(value: boolean) {
        this.btnFace.visible = value;
    }

}
